import React, { useContext, useEffect, useState } from 'react';
import { Link ,useNavigate,useLocation} from 'react-router-dom';
import { DataAppContext } from '../../DataContext';
import { FaBars, FaTimes } from 'react-icons/fa';

const LeftPanel = () => {
    const localContext = useContext(DataAppContext);
    const navigate = useNavigate();
    const location = useLocation();
    const usertype = localStorage.getItem('usertype');
    const { appstate,toggleLeftPanel } = localContext;
    const { showmenu,loginstatus, leftPanelVisible  } = appstate;
    const [activeItem, setActiveItem] = useState('/admindashboard');
    useEffect(() => {
        if (location.pathname === '/' || location.pathname === '') {
            navigate('/admindashboard');
        } else {
        setActiveItem(location.pathname);
        }
    }, [location.pathname]);
    
    if(!loginstatus){
        navigate('/login');
    }
    const [test, setTest] = useState(false);
    useEffect(() => {
        setTest(true);
    }, [localContext.appstate])

    useEffect(() => {
        if (window.innerWidth < 768 && appstate.leftPanelVisible) {
            toggleLeftPanel();
        }
    }, [location.pathname]);      

    return (

        <>
            <aside id="left-panel" className={`left-panel bg-light border-end ${leftPanelVisible ? 'd-block' : 'd-none'}`} >
                <nav className="navbar navbar-expand-sm navbar-default">
                    <div id="main-menu" className="main-menu collapse navbar-collapse">

                        <ul className="nav navbar-nav"  onClick={() => window.innerWidth < 768 && toggleLeftPanel()}>

                            {/* <li className="menu-title">&nbsp;</li> */}

                            {
                                (true) && (
                                    <>
                                        {/* <li className="menu-item-has-children dropdown"></li>
                                        <li className="menu-item-has-children dropdown"></li> */}
                                        <li className="menu-title">Admin Options</li>
                                        
                                        <li className={`menu-item-has-children dropdown ${activeItem === '/admindashboard' ? 'active bg-info text-white rounded' : ''}`}>
                                            <Link to='/admindashboard' className={`${activeItem === '/admindashboard' ? 'text-white' : ''}`} >Dashboard</Link>
                                        </li>
                                        <li className={`menu-item-has-children dropdown ${activeItem === '/userslist' ? 'active bg-info text-white rounded' : ''}`}>
                                            <Link to='/userslist' className={`${activeItem === '/userslist' ? 'text-white' : ''}`}  >Users</Link>
                                        </li>
                                        <li className={`menu-item-has-children dropdown ${activeItem === '/employerusers' ? 'active bg-info text-white rounded' : ''}`}>
                                           <Link to='/employerusers' className={`${activeItem === '/employerusers' ? 'text-white' : ''}`}  >Employer Users</Link>
                                       </li>
                                       <li className={`menu-item-has-children dropdown ${activeItem === '/candidate_details' ? 'active bg-info text-white rounded' : ''}`}>
                                            <Link to='/candidate_details' className={`${activeItem === '/candidate_details' ? 'text-white' : ''}`} >Candidate List</Link>
                                        </li>

                                        <li className={`menu-item-has-children dropdown ${activeItem === '/companieslist' ? 'active bg-info text-white rounded' : ''}`}>
                                            <Link to='/companieslist' className={`${activeItem === '/companieslist' ? 'text-white' : ''}`}  >Companies</Link>
                                        </li>
                                        <li className={`menu-item-has-children dropdown ${activeItem === '/joblist' ? 'active bg-info text-white rounded' : ''}`}>
                                            <Link to='/joblist' className={`${activeItem === '/joblist' ? 'text-white' : ''}`}  >Job List</Link>
                                        </li>
                                        <li className={`menu-item-has-children dropdown ${activeItem === '/job-applications' ? 'active bg-info text-white rounded' : ''}`}>
                                            <Link to='/job-applications' className={`${activeItem === '/job-applications' ? 'text-white' : ''}`} >Job Applications</Link>
                                        </li>
                                        <li className={`menu-item-has-children dropdown ${activeItem === '/interviews' ? 'active bg-info text-white rounded' : ''}`}>
                                            <Link to='/interviews' className={`${activeItem === '/interviews' ? 'text-white' : ''}`} >Interviews</Link>
                                        </li>
                                        <li className={`menu-item-has-children dropdown ${activeItem === '/hrlist' ? 'active bg-info text-white rounded' : ''}`}>
                                            <Link to='/hrlist' className={`${activeItem === '/hrlist' ? 'text-white' : ''}`}  >HR List</Link>
                                        </li>
                                        <li className={`menu-item-has-children dropdown ${activeItem === '/skills' ? 'active bg-info text-white rounded' : ''}`}>
                                            <Link to='/skills' className={`${activeItem === '/skills' ? 'text-white' : ''}`} >Skills</Link>
                                        </li>
                                        <li className={`menu-item-has-children dropdown ${activeItem === '/department' ? 'active bg-info text-white rounded' : ''}`}>
                                            <Link to='/department' className={`${activeItem === '/department' ? 'text-white' : ''}`}  >Departments</Link>
                                        </li>
                                        <li className={`menu-item-has-children dropdown ${activeItem === '/noticelist' ? 'active bg-info text-white rounded' : ''}`}>
                                            <Link to='/degreelist' className={`${activeItem === '/degreelist' ? 'text-white' : ''}`} >Degree List</Link>
                                        </li>
                                        <li className={`menu-item-has-children dropdown ${activeItem === '/noticelist' ? 'active bg-info text-white rounded' : ''}`}>
                                            <Link to='/noticelist' className={`${activeItem === '/noticelist' ? 'text-white' : ''}`} >Notice List</Link>
                                        </li>
                                        <li className={`menu-item-has-children dropdown ${activeItem === '/Complaints' ? 'active bg-info text-white rounded' : ''}`}>
                                            <Link to='/Complaints' className={`${activeItem === '/Complaints' ? 'text-white' : ''}`} >Complaints</Link>
                                        </li>
                                        <li className={`menu-item-has-children dropdown ${activeItem === '/ourteam' ? 'active bg-info text-white rounded' : ''}`}>
                                            <Link to='/ourteam' className={`${activeItem === '/ourteam' ? 'text-white' : ''}`} >Our Team</Link>
                                        </li>                                    
                                                                                                                  
                                        <li className={`menu-item-has-children dropdown ${activeItem === '/feedback' ? 'active bg-info text-white rounded' : ''}`}>
                                            <Link to='/feedback' className={`${activeItem === '/feedback' ? 'text-white' : ''}`} >Feedback</Link>
                                        </li>
                                        <li className={`menu-item-has-children dropdown ${activeItem === '/industries' ? 'active bg-info text-white rounded' : ''}`}>
                                            <Link to='/industries' className={`${activeItem === '/industries' ? 'text-white' : ''}`} >Industries</Link>
                                        </li>
                                        <li className={`menu-item-has-children dropdown ${activeItem === '/testimonials' ? 'active bg-info text-white rounded' : ''}`}>
                                            <Link to='/testimonials' className={`${activeItem === '/testimonials' ? 'text-white' : ''}`} >Testimonials</Link>
                                        </li>
                                        
                                        <li className={`menu-item-has-children dropdown ${activeItem === '/FAQPage' ? 'active bg-info text-white rounded' : ''}`}>
                                            <Link to='/FAQPage' className={`${activeItem === '/FAQPage' ? 'text-white' : ''}`}>FAQ</Link>
                                        </li>
                                        <li className={`menu-item-has-children dropdown ${activeItem === '/ContactList' ? 'active bg-info text-white rounded' : ''}`}>
                                            <Link to='/ContactList' className={`${activeItem === '/ContactList' ? 'text-white' : ''}`}  >Contact</Link>
                                        </li>
                                        <li className={`menu-item-has-children dropdown ${activeItem === '/categories' ? 'active bg-info text-white rounded' : ''}`}>
                                            <Link to='/categories' className={`${activeItem === '/categories' ? 'text-white' : ''}`}  >Category</Link>
                                        </li>
                                        <li className={`menu-item-has-children dropdown ${activeItem === '/citylist' ? 'active bg-info text-white rounded' : ''}`}>
                                            <Link to='/citylist' className={`${activeItem === '/citylist' ? 'text-white' : ''}`}  >Cities</Link>
                                        </li>


                                        {/* <li className="menu-title">Student Options</li>
                                        <li className="menu-item-has-children dropdown"><Link to='/profile' >Profile</Link></li>
                                        <li className="menu-item-has-children dropdown"><Link to='/dashboard' >Dashboard</Link></li>
                                        <li className="menu-item-has-children dropdown"><Link to='/examlist' >Upcoming Exams</Link></li>
                                        <li className="menu-item-has-children dropdown"><Link to='/examtaken' >Exams Taken</Link></li> */}
                                    </>
                                )
                            }

                            {/* {
                                (usertype === 'student') && (
                                    <>
                                        <li className="menu-item-has-children dropdown"><Link to='/profile' >Profile</Link></li>
                                        <li className="menu-item-has-children dropdown"><Link to='/dashboard' >Dashboard</Link></li>
                                        <li className="menu-item-has-children dropdown"><Link to='/examlist' >Upcoming Exams</Link></li>
                                        <li className="menu-item-has-children dropdown"><Link to='/examtaken' >Exams Taken</Link></li>
                                    </>
                                )
                            } */}
                        </ul>
                    </div>
                </nav>

            </aside>
        </>
    )
}

export default LeftPanel;